import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { DynamicContactType } from '../parts/RenderSections';

const useClearInputs = ({
  type,
  handleChangeOwnSustainer,
}: {
  type: DynamicContactType;
  handleChangeOwnSustainer: (next: boolean) => void;
}) => {
  const { watch, formState } = useFormContext();
  const ownSustainer = watch('ownSustainer');

  const isSustainerTypeTouched = formState.touchedFields['sustainerType'];

  useEffect(() => {
    if (type === 'sustainerFile' && !ownSustainer && isSustainerTypeTouched) {
      handleChangeOwnSustainer(ownSustainer);
    }
  }, [handleChangeOwnSustainer, isSustainerTypeTouched, ownSustainer, type]);
};

export default useClearInputs;
